import { SubmitFormButton } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { ArrowChevronLeftIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
import DisabledIcon from './disabled_send.svg';
import SendIcon from './send.svg';
const iconCss = "i1njcw10";
const Icon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(iconCss, props.className)} />;
});
const footerContainerCss = "fnlfmdo";
const FooterContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerContainerCss, props.className)} />;
});
const rightOffsetContainerCss = "r1wri4fd";
const RightOffsetContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rightOffsetContainerCss, props.className)} />;
});
export const Footer = ({
  onBack,
  onCancel,
  shouldDisableSendButton = false
}) => <FooterContainer>
    <>
      <div>
        {onBack && <Button decoration="secondary-outline" onClick={onBack} responsive={false}>
          <ArrowChevronLeftIcon />
          {I18n.t('publisher.action.back')}
        </Button>}
      </div>
      <RightOffsetContainer>
        <Button decoration="ghost" onClick={onCancel} responsive={false}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <SubmitFormButton responsive={false} disabled={shouldDisableSendButton}>
          {shouldDisableSendButton ? <Icon src={DisabledIcon} aria-hidden /> : <Icon src={SendIcon} aria-hidden />}
          {I18n.t('publisher.send_from_calendly.action.send')}
        </SubmitFormButton>
      </RightOffsetContainer>
    </>
  </FooterContainer>;

require("./footer.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./footer.js");